var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import dayjs from 'dayjs';
import { Facility } from '../../models/facility';
import config from '../../services/config';
import { getString, setString } from '../../strings';
import * as authActions from '../actions/auth';
import * as websiteActions from '../actions/website';
var initialState = {
  facility: null,
  rehydrated: false,
  flaggedInmateDevices: 0,
  devicesWithoutGroups: [],
  stationsCount: 0,
  disabledStationsCount: 0,
  disabledStationsPreview: [],
  housingUnitsWithCommunicationsAltered: []
};
function loadConfigFromFacility(facility) {
  var _a, _b;
  config.name = facility.name;
  config.features = [];
  // If we get a new timezone value, set dayjs default value
  if (config.timezone != facility.timezone) {
    dayjs.tz.setDefault(facility.timezone);
  }
  config.timezone = facility.timezone;
  facility.features.map(function (feature) {
    switch (feature) {
      case 'Video Calls':
        config.features.push('video-call');
        break;
      case 'Reference Material':
        config.features.push('reference-material');
        break;
      case 'Job Search':
        config.features.push('job-search');
        break;
      case 'Inmate Requests':
        config.features.push('inmate-requests');
        break;
      case 'Commissary Ordering':
        config.features.push('commissary');
        break;
      case 'Law Library':
        config.features.push('law-library');
        break;
      case 'Kiosk Audio Calls':
        config.features.push('audio-call');
        break;
      case 'Wireless Audio Calls':
        config.features.push('wireless-audio-calls');
        break;
      case 'Wireless Video Calls':
        config.features.push('video-call');
        break;
      case 'Wireless Video Visitations':
        config.features.push('visitation');
        break;
      case 'Prepaid Collect Calls':
        config.features.push('audio-call');
        break;
      case 'Voicemail':
        config.features.push('voicemail');
        break;
      case 'Video Visitation':
        config.features.push('visitation');
        break;
      case 'Audio Visitation':
        config.features.push('audio-visitation');
        break;
      case 'Inmate Communication Policy':
        config.features.push('inmate-communication-policy');
        break;
      case 'Transcription':
        config.features.push('transcription');
        break;
      case 'Music':
        config.features.push('music');
        break;
      case 'Reference Materials':
        config.features.push('reference-material');
        break;
      case 'Person Search':
        config.features.push('person-search');
        break;
      case 'Post Office':
        config.features.push('post-office');
        break;
    }
  });
  if (facility.featureTexting) {
    config.features.push('texting');
  }
  // Stop configuration if we don't have the full facility data yet
  if (facility.getConfigurationValue == null) {
    return;
  }
  if (facility.getConfigurationValue('VisitTimeLimitMinutes')) {
    config.visitation.defaultTimeLimit = Number(facility.getConfigurationValue('VisitTimeLimitMinutes'));
  }
  if (facility.getConfigurationValue('VisitTimeLimitOptions')) {
    config.visitation.timeLimitOptions = JSON.parse(facility.getConfigurationValue('VisitTimeLimitOptions'));
  }
  if (facility.getConfigurationValue('VisitationVisitorOptionalFields')) {
    config.visitation.visitationVisitorOptionalFields = facility.getConfigurationValue('VisitationVisitorOptionalFields').split(',');
  }
  if (facility.getConfigurationValue('InmatePINLength')) {
    config.inmate.pinLength = Number(facility.getConfigurationValue('InmatePINLength'));
  }
  if (facility.getConfigurationValue('RelcoreSiteBrand')) {
    setString('Brand', facility.getConfigurationValue('RelcoreSiteBrand'));
    setString('ResultsApiError', getString('ResultsApiError').replace('Reliance Telephone', facility.getConfigurationValue('RelcoreSiteBrand')));
  }
  config.inmate.housingUnitsEnabled = ((_a = facility.housingUnits) === null || _a === void 0 ? void 0 : _a.length) > 0;
  // If we get this value, assume that it is a site based site
  if (facility.getConfigurationValue('ConnectServerIp')) {
    config.connectServer.url = (_b = process.env.CONNECT_SERVER_URL) !== null && _b !== void 0 ? _b : (location.protocol === 'https:' ? 'wss://' : 'ws://') + window.location.hostname + '/connect-server';
    config.nodeServer = process.env.APP_ENV == 'development' ? process.env.NODE_SERVER : window.location.hostname;
  }
}
export default function (state, action) {
  var _a;
  if (state === void 0) {
    state = initialState;
  }
  switch (action.type) {
    case websiteActions.BASE_DATA_LOAD_SUCCESS:
      var baseDataFacility = new Facility(action.data);
      // Set config values
      loadConfigFromFacility(baseDataFacility);
      return __assign(__assign({}, state), {
        facility: baseDataFacility,
        housingUnitsWithCommunicationsAltered: (_a = baseDataFacility.housingUnits) === null || _a === void 0 ? void 0 : _a.filter(function (unit) {
          if (unit.audioCallingEnabled != null && unit.videoCallingEnabled != null && unit.textingEnabled != null && unit.communicationsEnabled != null) {
            return !unit.audioCallingEnabled || !unit.videoCallingEnabled || !unit.textingEnabled || !unit.communicationsEnabled;
          }
          return false;
        })
      });
    case authActions.AUTH_TOKEN_LOAD_SUCCESS:
      var facility = new Facility(action.accessToken.data.facilityUser.facility);
      // Set config values
      loadConfigFromFacility(facility);
      return __assign(__assign({}, state), {
        facility: facility,
        housingUnitsWithCommunicationsAltered: facility.housingUnits.filter(function (unit) {
          if (unit.audioCallingEnabled != null) {
            return !unit.audioCallingEnabled;
          }
          return false;
        })
      });
    case 'NODE_SERVER/STATS':
      var statsFacility = new Facility(action.data.facility);
      return __assign(__assign({}, state), {
        flaggedInmateDevices: action.data.flaggedInmateDevices,
        devicesWithoutGroups: action.data.devicesWithoutGroups,
        stationsCount: action.data.stationsCount != undefined ? action.data.stationsCount : state.stationsCount,
        disabledStationsCount: action.data.disabledStationsCount != undefined ? action.data.disabledStationsCount : state.disabledStationsCount,
        disabledStationsPreview: action.data.disabledStationsPreview != undefined ? action.data.disabledStationsPreview : state.disabledStationsPreview,
        facility: statsFacility
      });
    case 'persist/REHYDRATE':
      var newState = __assign({}, state);
      // Track if we rehydrated the root state
      if (action.key == 'root') {
        newState.rehydrated = true;
      }
      // Set facility if available
      if (action && action.payload && action.payload.common && action.payload.common.facility) {
        var facility_1 = new Facility(action.payload.common.facility);
        // Set config values
        loadConfigFromFacility(facility_1);
        return __assign(__assign({}, newState), {
          facility: facility_1
        });
      }
      return newState;
  }
  return state;
}